var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fit"},[(_vm.show)?_vm._t("default"):_c('NotFound')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }